import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleFour from '../components/ArticleFour'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleFour)
